export default __webpack_public_path__ + "static/media/4_2C3FTG0-min.862e27cf.jpg";